import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/images/logo.jpg';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <img
              src={logo}
              alt="Gelwel"
              className="footer-logo"
            />
            <h3 className="footer-brand-name">Gelwel</h3>
            <p className="footer-brand-tagline">Connect with your vibe</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-column-title">Company</h4>
              <ul className="footer-column-list">
                <li><a href="#about" className="footer-link">About Us</a></li>
                <li><a href="#careers" className="footer-link">Careers</a></li>
                <li><a href="#press" className="footer-link">Press</a></li>
                <li><a href="#blog" className="footer-link">Blog</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Support</h4>
              <ul className="footer-column-list">
                <li><a href="#help" className="footer-link">Help Center</a></li>
                <li><Link to="/contact" className="footer-link">Contact</Link></li>
                <li><a href="#safety" className="footer-link">Safety</a></li>
                <li><Link to="/community-policies" className="footer-link">Community</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Legal</h4>
              <ul className="footer-column-list">
                <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
                <li><Link to="/terms" className="footer-link">Terms of Use</Link></li>
                <li><Link to="/cookies" className="footer-link">Cookie Policy</Link></li>
                <li><Link to="/policies" className="footer-link">All Policies</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Gelwel. All rights reserved.
          </p>
        </div>
        <div style={{ marginTop: "10px" }}>
          <Link to="/AdminLogin" className="footer-admin-link">
            Admin Login
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
